export class UserAccountProfile {
    constructor (options) {
        options = options || {};
        this.id = _.parseNumber(options.id, 0);
        this.uniqueId = options.uniqueId || options.UniqueId || null;
        this.notificationEmail = options.notificationEmail || options.NotificationEmail || false;
        this.htmlEmail = options.htmlEmail || options.HTMLEmail || true;
        this.notificationSms = options.notificationSms || options.NotificationSms || false;
        this.mfaPhoneNumber = options.mfaPhoneNumber || options.cellPhone || '';
        this.cellPhone = options.overrideCellPhone || options.cellPhone || '';
    }
}